import { type OrderStatusType } from "@relay/paymentProviderLink_OrderFragment.graphql";

export const PAID_ORDER_STATUSES: readonly OrderStatusType[] = [
	"PurchasedAwaitingAccount",
	"Purchased",
	"PaymentReceived",
	"ClosedByAdmin",
];

export const isOrderPaid = (status: OrderStatusType) => PAID_ORDER_STATUSES.includes(status);
